import PropTypes from 'prop-types';

const pinStyle = {
  cursor: 'pointer',
  pointerEvents: 'auto',
  filter: 'drop-shadow(0px 2px 5px rgba(0, 0, 0, .2))',
};

const MapPinAdded = ({ fill='#FED844', stroke='#052B52', width=69, height=84, ariaLabel='', onClick }) => {
  return (
    <svg
      //
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 85 100"
      style={{ ...pinStyle }}
      width={width}
      height={height}
      aria-label={ariaLabel}
      onClick={onClick}
    >
      <defs>
        <path
          id="map-pin-normal-added"
          d="M50.067 27.056L32.99 44.782c-.915.95-2.4.946-3.313-.008l-8.584-8.99a2.464 2.464 0 0 1-.676-1.722 2.462 2.462 0 0 1 .683-1.717l1.06-1.102a2.292 2.292 0 0 1 1.653-.71c.601 0 1.204.24 1.66.718l5.877 6.155 14.355-14.902a2.278 2.278 0 0 1 3.314.008l1.055 1.105c.437.458.677 1.07.676 1.721a2.466 2.466 0 0 1-.683 1.718M34.5 1C16.58 1 2 15.877 2 34.164c0 7.62 5.168 17.938 15.359 30.665 7.359 9.189 14.6 16.217 14.905 16.512a3.204 3.204 0 0 0 4.47 0c.307-.295 7.549-7.323 14.908-16.512C61.832 52.102 67 41.784 67 34.164 67 15.877 52.42 1 34.5 1"
        />
      </defs>
      <use fill={fill} fillRule="evenodd" stroke={stroke} strokeWidth="2.5" xlinkHref="#map-pin-normal-added" />
    </svg>
  );
};

MapPinAdded.propTypes = {
  fill: PropTypes.string,
  stroke: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  ariaLabel: PropTypes.string,
  onClick: PropTypes.func.isRequired,
};

export default MapPinAdded;
